import { AfterViewInit, Component } from '@angular/core';
import { HCaptchaService } from 'src/app/services/hcaptcha.service';

@Component({
  selector: 'captcha-component',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss']
})

export class CaptchaComponent implements AfterViewInit {
  containerID = 'h-captcha';
  passiveContainerID = 'h-captcha-response';

  constructor(
    private hCaptchaService: HCaptchaService,
  ) { }

  ngAfterViewInit() {
    this.hCaptchaService.renderCaptcha(this.containerID, this.passiveContainerID);
  }
}
